@if (!operation?.config?.iframe) {
    <tec-pwcs-layout [ngClass]="{ dark: designService.isDarkMode() }">
        <ng-container content>
            <!-- DISPOSITIVO SECUNDARIO -->
            @if (shouldCheckDevice && !process?.primary_device) {
                <tec-tile
                    type="status"
                    [title]="'FINISH.SECONDARY_DEVICE_TITLE' | translate"
                    [subtitle]="'FINISH.SECONDARY_DEVICE_DESCRIPTION' | translate"
                    icon="icon-capture-opened-window"
                    tagIconStatus="info"
                ></tec-tile>
            }
            <!-- DISPOSITIVO PRINCIPAL -->
            @if (!shouldCheckDevice || process?.primary_device) {
                @if (isPendingReview) {
                    <tec-tile
                        type="status"
                        [title]="pendingTitle()"
                        [subtitle]="pendingDescription() || null"
                        icon="icon-pending-check"
                        tagIconStatus="info"
                    ></tec-tile>
                } @else {
                    @if (finishOperationStatus === operationStatus.OK) {
                        <tec-tile
                            type="status"
                            [tagIconStatus]="'success'"
                            [title]="okTitle()"
                            [subtitle]="okDescription() || null"
                            icon="icon-check"
                        ></tec-tile>
                    }
                    @if (finishOperationStatus === operationStatus.KO) {
                        <tec-tile
                            type="status"
                            [title]="koTitle()"
                            [subtitle]="koDescription() || null"
                            icon="icon-alert"
                        ></tec-tile>
                    }
                }
                @if (finishOperationStatus === operationStatus.CANCELLED) {
                    <tec-tile
                        type="status"
                        [title]="cancelledTitle()"
                        [subtitle]="cancelledDescription()"
                        icon="icon-log-out"
                        tagIconStatus="info"
                    ></tec-tile>
                }
            }
        </ng-container>
        <ng-container actions>
            @if (shouldCheckDevice && !process?.primary_device) {
                <tec-button size="lg" (click)="continueOnThisDevice()">
                    {{ 'GENERAL.BUTTON.CONTINUE_THIS_DEVICE' | translate }}
                </tec-button>
            }
        </ng-container>
        @if ((designService.configDesign$ | async)?.showWatermark) {
            <tec-watermark type="default" />
        }
    </tec-pwcs-layout>
}

@if (operation?.config?.iframe) {
    <tec-pwcs-layout [ngClass]="{ 'pwcs-style-old': true, dark: designService.isDarkMode() }">
        <ng-container content>
            @if (operation.config.status === operationStatus.OK) {
                <tec-tile
                    type="status"
                    [tagIconStatus]="'success'"
                    [title]="okTitle()"
                    [subtitle]="okDescription() || null"
                    icon="icon-check"
                ></tec-tile>
            }
            @if (operation.config.status === operationStatus.KO) {
                <tec-tile
                    type="status"
                    [title]="koTitle()"
                    [subtitle]="koDescription() || null"
                    icon="icon-alert"
                ></tec-tile>
            }
        </ng-container>
        <!-- <ng-container actions>
        <ng-container *ngIf="operation.config.status === 'OK'">
            <tec-button (clickEvent)="sendDataIframe(IFRAME_RESULT.OK)">
                {{ 'GENERAL.BUTTON.CONTINUE' | translate }}
            </tec-button>
        </ng-container>
        <ng-container *ngIf="operation.config.status === operationStatus.KO">
            <tec-button (clickEvent)="sendDataIframe(IFRAME_RESULT.KO)">
                {{ 'GENERAL.BUTTON.EXIT' | translate }}
            </tec-button>
        </ng-container>
    </ng-container> -->
    </tec-pwcs-layout>
}
